import React from 'react';
import { Navigate } from 'react-router';
import { isDemoLoginAllowedOrigin } from '@/lib/demoLoginOrigins';

export interface DemoRouteProps {
    children: React.ReactNode;
}

export const DemoRoute = ({ children }: DemoRouteProps): React.ReactNode => {
    if (isDemoLoginAllowedOrigin(window.location.origin)) {
        return children;
    }
    return <Navigate to="/" replace />;
};
